var VINAGECKO = VINAGECKO || {};
(function ($) {
  var pixelRatio = !!window.devicePixelRatio ? window.devicePixelRatio : 1;
  var $window = $(window),
      body = $("body"),
      deviceAgent = navigator.userAgent.toLowerCase(),
      isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
      imageZoomThreshold = 20;
  VINAGECKO.general = {
    init: function(){
      VINAGECKO.general.toolTipInit();              
      VINAGECKO.general.searchPopupInit();
      if($('.vina-carousel.owl-carousel').length > 0) {
        var carousel = $('.vina-carousel.owl-carousel');

        carousel.each(function(){
          VINAGECKO.general.carouselInit($(this));
        }); 
      }
    },
    toolTipInit: function() {
      $('[data-toggle="tooltip"]').tooltip();
    },
    carouselInit: function(carousel) {
      var data_carousel = carousel.parent().find('.data-carousel');			        

      if(data_carousel.data('auto')) {
        var autoplay = data_carousel.data('auto');
      }else{
        var autoplay = false;
      }

      carousel.owlCarousel({
        items				: data_carousel.data('items'),
        itemsDesktop      : [1199,data_carousel.data('itemsdesktop')],
        itemsDesktopSmall : [991,data_carousel.data('itemsdesktopsmall')],
        itemsTablet       : [768,data_carousel.data('itemstablet')],
        itemsMobile       : [479,data_carousel.data('itemsmobile')],
        slideSpeed		: 500,
        autoPlay			: autoplay,
        pagination		: data_carousel.data('paging'),
        addClassActive	: true,
        navigation		: data_carousel.data('nav'),
        navigationText	: [data_carousel.data('prev'),data_carousel.data('next')],
      });
    },
    searchPopupInit: function() {
      // Popup for Menu and Search Links in the Header
      if( ( $('#open-popup-search').length && $('.page-search-box').length ) || ( $('#open-popup-search-mobile').length && $('.page-search-box').length ) ){
        $('#open-popup-search, #open-popup-search-mobile').on('click', function () {
          $('.page-search-box').fadeIn(250);
          $('.page-search-box .search-query').focus();
        });
      }
      if( $('.close-page-search').length && $('.page-search-box').length ){
        $('.close-page-search').on('click', function () {
          $('.page-search-box').fadeOut(250);
        });
      }
    }
  };
  VINAGECKO.header = {
    init: function(){
      VINAGECKO.header.logoRetinaInit(); 
      if ($("#main-header").data('sticky') == true && $.fn.sticky) { 
        VINAGECKO.header.stickyInit();
      }
    },
    logoRetinaInit: function() {
      var $logoImg = $('.header-wrapper .header-container .logo img.x1');
      if (pixelRatio > 1) {
        if($('.template-index').length>0){
          $logoImg.attr('src', $logoImg.attr('src').replace(frontendData.logoHome, frontendData.logoHomeRetina));
        }else{
          $logoImg.attr('src', $logoImg.attr('src').replace(frontendData.logo, frontendData.logoRetina));
        }
      }
    },
    stickyInit: function(){
      $("#main-heade").sticky({ topSpacing: 0 });
      $("#main-header-mobil").sticky({ topSpacing: 0 });
    }
  };
  VINAGECKO.page = {
    init: function() {
      VINAGECKO.page.pageLoaderInit();

      if($('body').find('#resultLoading').attr('id') != 'resultLoading'){
        $('body').append('<div id="resultLoading" style="display:none"><div class="spinner"><div class="circle"></i></div><div class="bg"></div></div>');
      }

      $.browserSelector();

      if ($("html").hasClass("chrome")) {
        $.smoothScroll();
      }
      if ($("html").hasClass("safari")) {
        $.smoothScroll();
      }
      if (pixelRatio > 1) {
        VINAGECKO.page.imageRetinaInit();				
      }

      VINAGECKO.page.videoInit();

      if($('#popup_newsletter').length > 0){
        var newsletter = $('#popup_newsletter'); 
        VINAGECKO.page.newsletterPopupInit(newsletter);
      }

      $('.border-box, .border-left, .border-right').each(function() {
        var $this = $(this);
        $this.waypoint(function () {
          $this.addClass('animated');
        }, {offset: '90%'});
      });

    },
    pageLoaderInit: function(){
      if( $('#page-loader').length ) {
        setTimeout(function() {
          $( 'body' ).addClass( 'loaded' );
          setTimeout(function () {
            $('#page-loader').remove();
          }, 1500);
        }, 1500);
      }
    },
    imageRetinaInit: function(){
      $('img[data-srcX2]').each(function () {
        if ($(this).hasClass('lazy') || $(this).hasClass('lazyOwl')) {
          return;
        } else {
          $(this).attr('src', $(this).attr('data-srcX2'));
        }
      });
    },
    disableLinkMobile: function () {
      $('.products-grid').find('a.product-image').click(function(e){
        e.preventDefault();
        return false;
      });
    },    
    videoInit:function(){
      $(".container-main-video .upb_video-wrapper .upb_video-bg em").click(function () {
        if($(this).hasClass("fa-play")){
          $(".container-main-video .upb_video-wrapper .upb_video-bg video").get(0).play();
        }
        else
          $(".container-main-video .upb_video-wrapper .upb_video-bg video").get(0).pause();

        $(this).toggleClass("fa-pause").toggleClass("fa-play");

        return false;
      });
    },
    newsletterPopupInit: function(newsletter){
      $('#popup_newsletter .subcriper_label input').on('click', function(){
        if($(this).parent().find('input:checked').length){
          VINAGECKO.collection.createCookie('newsletterSubscribe', 'true', 1);
        } else {
          VINAGECKO.collection.readCookie('newsletterSubscribe'); 
        }
      });
      $('#popup_newsletter .input-box button.button').on('click', function(){
        var button = $(this);
        setTimeout(function(){
          if(!button.parent().find('input#popup-newsletter').hasClass('validation-failed')){ 
            VINAGECKO.collection.createCookie('newsletterSubscribe', 'true', 1);
          }
        }, 500);
      });
      if (VINAGECKO.collection.readCookie('newsletterSubscribe') == null) {
        $.colorbox({
          inline:true,
          href: newsletter,
          opacity:	0.3,
          speed:		500,
          innerWidth: newsletterData.width+'px',
          innerHeight: newsletterData.height+'px',
          fixed: true,
          onOpen: function(){
            $('#cboxContent').addClass('newsletterbox');
            $('#cboxLoadingGraphic').addClass('box-loading'); 
            $(".newsletterbox").css({
              'background-image' : 'url('+newsletterData.bg_image+')',
              'background-position' : 'left top',
              'background-repeat' : 'no-repeat',
              'background-color' : newsletterData.bg_color,
              'background-size' : 'cover'
            });
          },
          onComplete: function(){
            setTimeout(function(){
              $('#cboxLoadingGraphic').removeClass('box-loading');
            },800);
          },
          onClosed: function(){
            $.colorbox.remove();
            $('#cboxContent').removeClass('newsletterbox');
            $('#cboxContent').attr('style','');
          }
        });

        VINAGECKO.page.newsletterResize();

        $window.smartresize( function() {
          if($('#colorbox').find('.block-subscribe').length>0){
            VINAGECKO.page.newsletterResize();
          }
        });
      }  
    },
    newsletterResize: function() {
      var width = "90%";
      var height = newsletterData.height+"px"; 
      if($(window).width() > 960) { width = newsletterData.width }
      if($(window).height() > 700) { height = newsletterData.height }
      if($(window).width() <= 600) {
        $('.newsletterbox .block-subscribe').css({
          'width':'90%',
          'top': '10%'
        })
      }else {
        $('.newsletterbox .block-subscribe').css({
          'width':'90%',
          'top': '20%'
        })
      }
      $.colorbox.settings.height = height;
      $.colorbox.settings.width = width; 
      $.colorbox.resize({
        'height': height,
        'width': width
      }); 
    }
  };
  VINAGECKO.carouselSync = {
    init: function() {
      if( $('.carousel-sync2').length > 0 ) {
        var carousel_sync1 = $('.carousel-sync1');

        carousel_sync1.each(function(){
          var carousel_sync2 = $(this).parent().find('.carousel-sync2');
          VINAGECKO.carouselSync.carouselInit( $(this), carousel_sync2 );
        }); 
      }
    },
    carouselInit: function(carousel_sync1, carousel_sync2) {
      var data_carousel_sync1 = carousel_sync1.parent().find('.data-carousel-sync1');
      var data_carousel_sync2 = carousel_sync2.parent().find('.data-carousel-sync2');
      if(data_carousel_sync1.data('auto')) {
        var autoplay_sync1 = data_carousel_sync1.data('auto');
      }else{
        var autoplay_sync1 = false;
      }
      if(data_carousel_sync2.data('auto')) {
        var autoplay_sync2 = data_carousel_sync2.data('auto');
      }else{
        var autoplay_sync2 = false;
      }          

      carousel_sync1.owlCarousel({
        autoPlay: autoplay_sync1,
        singleItem : true,
        slideSpeed : data_carousel_sync1.data('slidespeed'),
        pagination: data_carousel_sync1.data('paging'),
        navigation: data_carousel_sync1.data('nav'),
        navigationText: [data_carousel_sync1.data('prev'),data_carousel_sync1.data('next')],
        addClassActive: true,
        afterAction : syncPosition,
        responsiveRefreshRate : 200,
      });
      carousel_sync2.owlCarousel({
        autoPlay: autoplay_sync2,
        items : data_carousel_sync2.data('items'),
        itemsDesktop      : data_carousel_sync2.data('itemsdesktop'),
        itemsDesktopSmall : data_carousel_sync2.data('itemsdesktopsmall'),
        itemsTablet       : data_carousel_sync2.data('itemstablet'),
        itemsMobile       : data_carousel_sync2.data('itemsmobile'),
        pagination		  : false,
        addClassActive: true,
        afterInit : function(el){
          el.find(".owl-item").eq(0).addClass("synced");
        }
      });
      function syncPosition(el){
        var current = this.currentItem;
        carousel_sync2.find(".owl-item").removeClass("synced").eq(current).addClass("synced")
        if( carousel_sync2.data("owlCarousel") !== undefined ){
          syncCenter(current)
        }
      }
      function syncCenter(number){
        var sync2visible = carousel_sync2.data("owlCarousel").owl.visibleItems;
        var num = number;
        var found = false;
        for(var i in sync2visible){
          if(num === sync2visible[i]){
            var found = true;
          }
        }

        if(found===false){
          if(num>sync2visible[sync2visible.length-1]){
            carousel_sync2.trigger("owl.goTo", num - sync2visible.length+2)
          }else{
            if(num - 1 === -1){
              num = 0;
            }
            carousel_sync2.trigger("owl.goTo", num);
          }
        } else if(num === sync2visible[sync2visible.length-1]){
          carousel_sync2.trigger("owl.goTo", sync2visible[1])
        } else if(num === sync2visible[0]){
          carousel_sync2.trigger("owl.goTo", num-1)
        }

      }
      carousel_sync2.on("click", ".owl-item", function(e){
        e.preventDefault();
        var number = $(this).data("owlItem");
        carousel_sync1.trigger("owl.goTo",number);
      });

    },
  };
  VINAGECKO.collection = {
    init: function() {			
      if($('.product-deal .product-date').length > 0){
        var productsDeal = $('.product-date');

        productsDeal.each(function(){
          VINAGECKO.collection.productDealInit($(this));
        });
      }

      VINAGECKO.collection.layoutSwitch();

      if (VINAGECKO.collection.readCookie('products-listmode') != null) {
        VINAGECKO.collection.layoutListInit();
      }

      $(document).on("click", ".close-box", function(){
        $(this).parents('.box-popup').removeClass('show');
      })

      $(document).on("click", ".add-to-wishlist", function(e){ 
        e.preventDefault();
        VINAGECKO.collection.addToWishlist($(this));
      });

      $(document).on("click", ".remove-wishlist", function(e){ 
        e.preventDefault();
        VINAGECKO.collection.removeWishlist($(this));
      });

      $(document).on("click", ".add-to-cart", function(e) {
        e.preventDefault();
        VINAGECKO.collection.addToCart($(this));
      });

      $(document).on("click", ".btn-remove-cart", function(e) {
        e.preventDefault();
        VINAGECKO.collection.removeCartInit($(this).data('id'));
      });

      VINAGECKO.collection.quickshopInit();
      /*VINAGECKO.collection.shareCounts();*/
      VINAGECKO.collection.sidebarMenuInit();
      VINAGECKO.collection.layerFilterInit();
      VINAGECKO.collection.colorSwatchGridInit();
    },  
    createCookie:function(name, value, days) {
      var expires;

      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }

      document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
    },
    readCookie:function(name) {
      var nameEQ = escape(name) + "=";
      var ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return unescape(c.substring(nameEQ.length, c.length));
      }

      return null;
    },
    eraseCookie: function(name) {
      VINAGECKO.collection.createCookie(name, "", -1);
    },		
    colorSwatchGridInit: function(){
      $('.configurable-swatch-list li a').on('click', function(e){
        e.preventDefault();  
        var productImage = $(this).parents('.product-action').find('.product-image'); 
        productImage.find('img.main').attr('src', $(this).data('image'));  
      });
    },
    animateItems: function(productsInstance) {
      productsInstance.find(".product").each(function(aj) {
        $(this).delay(aj * 200).animate({
          opacity: 1
        }, 500, "easeOutExpo", function() {
          $(this).addClass("item-animated")
        })
      })
    },
    layoutSwitch: function() {
      var isSwitchingLayout = false;
      if( $('.toolbar .view-mode .layout-opt').data('alttemplate') == 'grid-template' ) {              
        VINAGECKO.collection.eraseCookie('products-listmode');
        $('.toolbar .view-mode .layout-opt').removeClass('active');
        $('.toolbar .view-mode span[data-alttemplate="grid-template"]').addClass('active');
      }
      $(document).on('click', 'span.layout-opt', function(e) {
        var products = $('#catproducts'),
            selectedLayout = $(this).data('layout');

        $('.toolbar .view-mode .layout-opt').removeClass('active');
        $(this).addClass('active');

        if(selectedLayout == 'list') {
          if (VINAGECKO.collection.readCookie('products-listmode') == null) {
            VINAGECKO.collection.createCookie('products-listmode', 1, 10);
          }
        }else{
          VINAGECKO.collection.eraseCookie('products-listmode');
        }

        if (isSwitchingLayout) {
          return;
        }
        isSwitchingLayout = true;
        products.animate({
          'opacity': 0
        }, 300);

        setTimeout(function() {
          products.find('.product').removeClass('product-layout-list product-layout-grid');
          products.find('.product').addClass('product-layout-' + selectedLayout);

          if ( $('.products-grid').length > 0 ) {
            $('.products-grid').children().css('min-height','0');
          }

          /*products.isotope('layout');*/

          products.animate({
            'opacity': 1
          }, 200);

          isSwitchingLayout = false;
        }, 300);

        e.preventDefault();
      });
    },
    layoutListInit: function(){
      var products = $('#catproducts');
      products.css('opacity',0);
      $('.toolbar .view-mode span[data-layout="grid"]').removeClass('active');
      $('.toolbar .view-mode span[data-layout="list"]').addClass('active');
      products.find('.product').removeClass('product-layout-list product-layout-grid');
      products.find('.product').addClass('product-layout-list'); 

      setTimeout(function() {
        products.animate({
          'opacity': 1
        }, 200);
      }, 300);
    },
    productDealInit: function(productDeal){ 
      var date = productDeal.data('date');

      if(date){
        var config = {date: date};
        $.extend(config, countdown); 
        $.extend(config, countdownConfig);
        if(countdownTemplate){
          config.template = countdownTemplate;
        }
        productDeal.countdown(config); 
      }
    },
    quickshopInit: function(){
      $(document).on("initproduct", "#product-form", function() {
        var e = $(this).find("#product-select");  

        if (1 == e.length) {
          var t = ($(this).find(".product-form"), productsObj["id" + $(this).data("product-id")]);

          new Shopify.OptionSelectors(e.attr("id"), {
            product: t,
            onVariantSelected: VINAGECKO.collection.selectCallback,
            enableHistoryState: !1
          }), t.available && t.options.length > 1 && Shopify.linkOptionSelectors(t), VINAGECKO.collection.createSwatch(t, $(this)), 1 == t.variants.length && "Default Title" == t.variants[0].title && $(".selector-wrapper").hide();

          for (var i = !1, a = 0; a < t.variants.length; a++) {
            var o = t.variants[a];

            if (o.available && 0 == i) {
              i = !0;
              for (var r = 0; r < o.options.length; r++) $(".single-option-selector:eq(" + r + ")").val(o.options[r]).trigger("change")
                }
          }
        }
      });
      $("#product-form").trigger("initproduct");

      $window.smartresize( function() {
        if($('#colorbox').find('.quick-view').length>0){
          VINAGECKO.collection.quickshopResize();
        }
      });

      $.colorbox.settings.maxWidth = "90%", $.colorbox.settings.width = "1000px";

      $(document).on("click", ".quickview", function() {
        var $prod = $(this).closest(".product");
        eval($prod.find("[data-id^=product-block-json-]").html());
        var template = $prod.find("[data-id^=product-block-template-]").html();

        return $.colorbox({ 
          opacity:	0.3,
          fixed: true,
          onOpen: function() {
            $("body").addClass("cbox-active")
          },
          onClosed: function() {
            $.colorbox.remove();
            $("body").removeClass("cbox-active");
            VINAGECKO.productMediaManager.destroyZoom();
          }, 
          html: [template].join(""),
          onComplete: function() {
            VINAGECKO.verticleScroll.init();
            if($('.owl-carousel').length > 0) {
              var carousel = $('.owl-carousel');

              carousel.each(function(){
                VINAGECKO.general.carouselInit($(this));
              }); 
            }
            VINAGECKO.productMediaManager.init();
            $("#product-form").trigger("initproduct");
            $.colorbox.resize(); 
            VINAGECKO.collection.quickshopResize();

            if(frontendData.enableCurrency) { 
              currenciesCallbackSpecial(".quick-view span.money");
            }
          }
        });
      }); 
    },
    createSwatch: function(e, t){
      var a = new Array;
      if (swatch_size_enable && a.push("Size"), swatch_color_enable && (a.push("Color"), a.push("Colour")), a.length > 0) {
        var o = ".png",
            r = !1,
            n = !1,
            s = 0,
            l = asset_url.substring(0, asset_url.lastIndexOf("?"));

        for (i = 0; i < e.options.length; i++) {
          var d = "";
          if (d = "object" == typeof e.options[i] ? e.options[i].name : e.options[i], r = !1, n = !1, a.indexOf(d) > -1) {
            r = !0, s = i;
            var c = d.toLowerCase();
            if (/color|colour/i.test(c) && (n = !0), r) {
              var u = "",
                  h = "";
              /size/i.test(d.toLowerCase()),
                u += '<div class="swatch ' + c + ' clearfix" data-option-index="' + s + '">', 
                u += '<div class="header"><span>' + d + "</span>" + h + "</div><div>";
              var f = new Array;

              for (j = 0; j < e.variants.length; j++) {
                var m = e.variants[j],
                    p = m.options[s],
                    y = VINAGECKO.collection.convertToSlug(p),
                    g = "swatch-" + s + "-" + y;
                f.indexOf(p) < 0 && (u += '<div data-value="' + p + '" class="swatch-element ' + (n ? "color" : "") + y + (m.available ? " available " : " soldout ") + '">', 
                                     n && (u += '<div class="tooltip">' + p + "</div>"), 
                                     u += '<input id="' + g + '" type="radio" name="option-' + s + '" value="' + p + '"' + (0 == j ? " checked " : "") + (m.available ? "" : " disabled") + "/>", 
                                     n ? (u += '<label for="' + g + '" class="img"><i style="background-color:' + y + "; background-image: url(" + l + y + o + ')">', 
                                          u += '<img class="crossed-out" src="' + l + 'soldout.png" />', 
                                          u += "</i></label>") : (u += '<label for="' + g + '">' + p, 
                                                                  u += '<img class="crossed-out" src="' + l + 'soldout.png" />', u += "</label>"), 
                                     u += "</div>", 

                                     f.push(p))
              }
              u += "</div></div>", t.find("#product-variants > select").after(u), t.find(".swatch :radio").change(function() {
                var e = $(this).closest(".swatch").attr("data-option-index"),
                    t = $(this).val();
                $(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change");
              })
            }
          }
        }
      }
    }, 
    convertToSlug: function(e) {
      return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
    },
    selectCallback: function(e, t) {
      if (e)
        for (i = 0; i < e.options.length; i++) $('.swatch[data-option-index="' + i + '"] :radio[value="' + e.options[i] + '"]').prop('checked', true);

      if (e)
        if (e.available) {
          if (e.compare_at_price > e.price) {
            $("#price").html('<del class="price_compare">' + Shopify.formatMoney(e.compare_at_price, money_format) + "</del>" + '<div class="price">' + Shopify.formatMoney(e.price, money_format) + "</div>")
          } else $("#price").html('<div class="price">' + Shopify.formatMoney(e.price, money_format) + "</div>");

          frontendData.enableCurrency && currenciesCallbackSpecial("#price span.money"), $("#add").removeClass("disabled").removeAttr("disabled").html($("#add").data("addtocart")), e.inventory_management && e.inventory_quantity <= 0 ? ($("#selected-variant").html(t.product.title + " - " + e.title), $("#backorder").removeClass("hidden")) : $("#backorder").addClass("hidden")
        } else $("#backorder").addClass("hidden"), $("#add").html($("#add").data("soldout")).addClass("disabled").attr("disabled", "disabled");
      else {
        var o = $("#add").data("unavailable"),
            r = $(".selector-wrapper select").filter(function() {
              return "" == $(this).val()
            }).length > 0;
        r && (o = $("#add").data("addtocart")), $("#price del").remove(), $("#backorder").addClass("hidden"), $("#add").html(o).addClass("disabled").attr("disabled", "disabled")
      }  
      if (e && e.featured_image) {
        var n = Shopify.Image.removeProtocol(e.featured_image.src);  
        $(".product-image-thumbs .thumb-link").filter('[data-zoom-image="' + n + '"]').trigger("click");
      }
      e && e.sku ? $("#sku").removeClass("hidden").find("span").html(e.sku) : $("#sku").addClass("hidden").find("span").html("")
    },
    quickshopResize: function(){
      var width = 1000,
          percentageWidth = .9,
          resizeTimer;

      resizeTimer && clearTimeout(resizeTimer), resizeTimer = setTimeout(function() {
        $("#cboxOverlay").is(":visible") && ($.colorbox.resize({
          width: $(window).width() > width + 20 ? width : Math.round($(window).width() * percentageWidth)
        }), $(".cboxPhoto").css({
          width: $("#cboxLoadedContent").innerWidth(),
          height: "auto"
        }), $("#cboxLoadedContent").height($(".cboxPhoto").height()), $.colorbox.resize())
      }, 300);
    },
    addToWishlist: function(wishlist){
      var form = wishlist.parents('form').serialize(),
          id = wishlist.data('id'),
          all = $("body").find(".wishlist-" + id + " .add-to-wishlist");  
      $.ajax({
        type: "POST",
        url: "/contact",
        async: !0,
        data: form,
        cache: !1,
        beforeSend: function() {
          $("#resultLoading").show();
        },
        success: function() {
          var productInfo = wishlist.closest('.product'),
              box = $('#wishlist-box'); 
          box.find(".product-link").attr("href", productInfo.find(".product-name a").attr("href")), 
            box.find(".product-img").attr("src", productInfo.find(".product-image img").attr("src")).attr("alt", productInfo.find(".product-name a").html()), 
            box.find(".product-title .product-link").html(productInfo.find(".product-name a").html()), 
            box.find(".product-price").html(productInfo.find(".price").html());

          all.each(function() {
            $(this).removeClass("add-to-wishlist").addClass("added").attr("title", $(this).attr("data-added")), 
              $(this).find("span").html($(this).attr("data-added")), 
              $(this).find("i").removeClass("fa-heart-o").addClass("fa-heart");
          }), setTimeout(function() {
            $("#resultLoading").hide();  
            box.addClass('show'), 
              setTimeout(function() {
              box.removeClass('show');
            }, 5e3)
          }, 500)
        },
        error: function(t) {
          var box = $('#error-notice'),
              i = $.parseJSON(t.responseText);
          box.find(".heading").html(i.message), box.find(".message").html(i.description), setTimeout(function() {
            $("#resultLoading").hide(),
              box.addClass('show'), 
              setTimeout(function() {
              box.removeClass('show');
            }, 5e3);
          }, 500);
        }
      })
    },
    removeWishlist: function(wishlist){
      var form = wishlist.parents('form').serialize(),
          item = wishlist.parents('.item'); 

      $.ajax({
        type: "POST",
        url: "/contact",
        data: form,
        beforeSend: function() {
          $("#resultLoading").show();
        },
        success: function() {
          $("#resultLoading").hide(), item.fadeOut(500);
        },
        error: function() {
          var box = $('#error-notice'),
              i = $.parseJSON(t.responseText);
          box.find(".heading").html(i.message), box.find(".message").html(i.description), setTimeout(function() {
            $("#resultLoading").hide(), 
              box.addClass('show'), 
              setTimeout(function() {
              box.removeClass('show');
            }, 5e3);
          }, 500);
        }
      })
    },
    addToCart: function(e){ 
      var form = e.parents('form');

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        data: form.serialize(),
        dataType: "json",
        beforeSend: function() {
          $("#resultLoading").show();
        },
        error: function(t) {
          var box = $('#error-notice'),
              i = $.parseJSON(t.responseText);
          box.find(".heading").html(i.message);
          box.find(".message").html(i.description);
          setTimeout(function() {
            $("#resultLoading").hide(); 
            box.addClass('show');
            setTimeout(function() {
              box.removeClass('show');
            }, 5e3);
          }, 500);
        },
        success: function(t) {
          Shopify.getCart(function(e) {
            var i = parseInt(form.find('input[name="quantity"]').val()),
                box = $('#cart-box');
            box.find(".product-link").attr("href", t.url), 
              box.find(".product-img").attr("src", Shopify.resizeImage(t.image, "medium")).attr("alt", t.title), 
              box.find(".product-title .product-link").html(t.title), 
              box.find(".product-price").html(Shopify.formatMoney(t.price, money_format)),    
              frontendData.enableCurrency && currenciesCallbackSpecial("#cart-box span.money");

            setTimeout(function() {
              $("#resultLoading").hide(); 
              box.addClass('show');
            }, 500), VINAGECKO.collection.updateCartInfo(e, ".cart-container .cart-wrapper .cart-inner-content");
          })
        },
        cache: !1
      });
    },
    updateCartInfo: function(cart, e){
      var c = $(e);
      if (c.length) {
        c.empty();

        $.each(cart, function(key,value){
          if(key == 'items'){
            var $html ='';

            if(value.length){ 
              $html += '<div class="cart-content">';
              $html += '<ul class="clearfix">';

              $.each(value, function(i, item) {
                $html += '<li class="item-cart">';
                $html += '<a class="product-image" href="'+ item.url +'"><img alt="'+ item.title +'" src="'+ Shopify.resizeImage(item.image, 'small') +'" /></a>';
                $html += '<div class="product-details row-fluid show-grid">';
                $html += '<p class="product-name"><a href="'+ item.url +'"><span>'+ item.title +'</span></a></p>';
                $html += '<div class="items"><span class="price">'+item.quantity+' &#215; <span class="amount">'+ Shopify.formatMoney(item.price, money_format) +'</span></span></div>';
                $html += '<div class="access"><a href="javascript: void(0);" class="btn-remove btn-remove-cart" data-id="'+item.variant_id+'" title="'+cartData.removeItemLabel+'"><i class="fa fa-close"></i></a></div>';
                $html += '</div>';
                $html += '</li>';
              });

              $html += '</ul>';
              $html += '<p class="subtotal"><span class="label">'+cartData.totalLabel+'</span><span class="price">'+Shopify.formatMoney(cart.total_price, money_format)+'</span></p>';
              $html += '</div>';
              $html += '<div class="cart-checkout"><a href="/cart" class="btn-button view-cart"><span>'+cartData.buttonViewCart+'</span></a><a href="/checkout" class="btn-button checkout-cart"><span>'+cartData.buttonCheckout+'</span></a></div>';
            }else{ 
              $html += '<div class="cart-content">';
              $html += '<p class="no-items-in-cart">'+cartData.noItemLabel+'</p>';
              $html += '</div>';
            }
          }
          c.append($html);
        });
      }
      if($('.icon-cart-header .cart-count').length > 0){
        $('.icon-cart-header .cart-count').html(cart.item_count);
      }
      if($('.icon-cart-header .money').length > 0){
        $('.icon-cart-header .money').html(Shopify.formatMoney(cart.total_price, money_format));
      }
      if(frontendData.enableCurrency){
        currenciesCallbackSpecial('.cart-wrapper .cart-inner span.money');
      }
    },
    removeCartInit: function(id,r){
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=0&id='+id,
        dataType: 'json', 
        beforeSend: function() {
          $(".cartloading").show();
        },
        success: function(t) { 
          if ((typeof r) === 'function') {
            r(t);
          }else {
            VINAGECKO.collection.updateCartInfo(t, ".cart-container .cart-wrapper .cart-inner-content"); 
            $(".cartloading").hide(); 
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      }); 
    },
    shareCounts: function() {
      var shareCounts = $('.sf-share-counts'),
          facebookCount = shareCounts.find('a.sf-share-fb'),
          twitterCount = shareCounts.find('a.sf-share-twit'),
          pinterestCount = shareCounts.find('a.sf-share-pin'),
          linkedInCount = shareCounts.find('a.sf-share-linked'),
          pageHref = window.location.href.replace(window.location.hash, '');

      // Facebook
      if (facebookCount.length > 0) {
        $.getJSON('https://graph.facebook.com/?id='+ pageHref +'&callback=?', function(data) {
          if (data.shares !== undefined && data.shares !== null) {
            facebookCount.find('.count').html(data.shares);
          }
          facebookCount.find('.count').addClass('animate');
        });
      }

      // Twitter
      if (twitterCount.length > 0) {
        $.getJSON('https://urls.api.twitter.com/1/urls/count.json?url='+pageHref+'&callback=?', function(data) {
          if (data.count !== undefined && data.count !== null) {
            twitterCount.find('.count').html(data.count);
          }
          twitterCount.find('.count').addClass('animate');
        });
      }

      // LinkedIn
      if (linkedInCount.length > 0) {
        $.getJSON('https://www.linkedin.com/countserv/count/share?url='+pageHref+'&callback=?', function(data) {
          if (data.count !== undefined && data.count !== null) {
            linkedInCount.find('.count').html(data.count);
          }
          linkedInCount.find('.count').addClass('animate');
        });
      }

      // Pinterest
      if (pinterestCount.length > 0) {
        $.getJSON('https://api.pinterest.com/v1/urls/count.json?url='+pageHref+'&callback=?', function(data) {
          if (data.count !== undefined && data.count !== null) {
            pinterestCount.find('.count').html(data.count);
          }
          pinterestCount.find('.count').addClass('animate');
        });
      }

      body.on('click', '.sf-share-link', function() {
        window.open($(this).attr('href'));
        return false;
      });
    },
    sidebarMenuInit: function(){
      $("#mobile-menu, #categories_nav").mobileMenu({
        accordion: true,
        speed: 400,
        closedSign: 'collapse',
        openedSign: 'expand',
        mouseType: 0,
        easing: 'easeInOutQuad'
      });
    },
    sortbyFilter: function() {
      $(document).on("change", ".sort-by .field", function(e) {
        e.preventDefault();
        var t = $(this), i = t.val();
        Shopify.queryParams.sort_by = i;
        VINAGECKO.collection.filterAjaxRequest();
      });
    },
    limitedAsFilter: function(){
      $(document).on("change", ".limited-view .field", function(e) {
        e.preventDefault();
        var t = $(this), i = t.val();
        Shopify.queryParams.view = i;
        VINAGECKO.collection.filterAjaxRequest();
      });
    },
    swatchListFilter: function() {
      $(document).on("click", ".narrow-by-list .item:not(.disable)", function() {
        var e = $(this),
            t = e.find("input").val(),
            i = [];
        if (Shopify.queryParams.constraint && (i = Shopify.queryParams.constraint.split("+")), !e.hasClass("active")) {
          var a = e.parents(".layer-filter").find(".active");
          a.length > 0 && a.each(function() {
            var e = $(this).data("handle");
            if ($(this).removeClass("active"), e) {
              var t = i.indexOf(e);
              t >= 0 && i.splice(t, 1)
            }
          })
        }
        if (t) {
          var o = i.indexOf(t);
          0 > o ? (i.push(t), e.addClass("active")) : (i.splice(o, 1), e.removeClass("active"))
        } 
        i.length ? Shopify.queryParams.constraint = i.join("+") : delete Shopify.queryParams.constraint, VINAGECKO.collection.filterAjaxRequest()
      });
    },
    layerFilterInit: function() {
      VINAGECKO.collection.sortbyFilter();
      VINAGECKO.collection.limitedAsFilter();
      //VINAGECKO.collection.paginationActionInit();
      VINAGECKO.collection.swatchListFilter();
      VINAGECKO.collection.layerClearAllFilter();
      VINAGECKO.collection.layerClearFilter(); 
    }, 
    filterCreateUrl: function(e) {
      var t = $.param(Shopify.queryParams).replace(/%2B/g, "+");
      return e ? "" != t ? e + "?" + t : e : location.pathname + "?" + t
    },
    filterAjaxRequest: function(e) {
      delete Shopify.queryParams.page;
      var t = VINAGECKO.collection.filterCreateUrl(e);
      VINAGECKO.collection.filterGetContent(t)
    },
    filterGetContent: function(e) {
      $.ajax({
        type: "get",
        url: e,
        beforeSend: function() {
          $("#resultLoading").show();
        },
        success: function(t) {
          var i = t.match("<title>(.*?)</title>")[1]; 
          $("#collection-main").empty().html($(t).find("#collection-main").html()),
            $(".narrow-by-list").empty().html($(t).find(".narrow-by-list").html()), 
            $(".pagination").empty().html($(t).find(".pagination").html()), 
            $(".main-breadcrumbs").empty().html($(t).find(".main-breadcrumbs").html()),  
            History.pushState({
            param: Shopify.queryParams
          }, i, e), setTimeout(function() {
            $("html,body").animate({
              scrollTop: $(".toolbar").offset().top
            }, 500)
          }, 100);

          $("#resultLoading").hide();

          if (VINAGECKO.collection.readCookie('products-listmode') != null) {
            VINAGECKO.collection.layoutListInit();
          }

          VINAGECKO.collection.layerClearFilter(); 
          VINAGECKO.collection.layerClearAllFilter();
          VINAGECKO.collection.colorSwatchGridInit();
          VINAGECKO.footer.mobileAccordionInit();
          SPR.registerCallbacks();
          SPR.initRatingHandler();
          SPR.initDomEls();
          SPR.loadProducts();
          SPR.loadBadges();
          frontendData.enableCurrency && currenciesCallbackSpecial(".products-grid span.money");
        },
        error: function() {
          $("#resultLoading").hide();
        }
      });
    },
    layerClearFilter: function() {
      $(".narrow-by-list .narrow-item").each(function() {
        var e = $(this);

        e.find("input:checked").length > 0 && e.find(".clear").click(function(t) {
          var i = [];
          Shopify.queryParams.constraint && (i = Shopify.queryParams.constraint.split("+")), e.find("input:checked").each(function() {
            var e = jQuery(this),
                t = e.val();
            if (t) {
              var a = i.indexOf(t);
              a >= 0 && i.splice(a, 1)
            }
          }), i.length ? Shopify.queryParams.constraint = i.join("+") : delete Shopify.queryParams.constraint, VINAGECKO.collection.filterAjaxRequest(), t.preventDefault()
        })
      })
    },
    layerClearAllFilter: function() {
      $('.narrow-by-list').on("click", ".clearall", function(e) {
        e.preventDefault();
        delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, VINAGECKO.collection.filterAjaxRequest();
      })
    }
  };

  VINAGECKO.productMediaManager = {
    destroyZoom: function() {
      $('.zoomContainer').remove();
      $('.product-image-gallery .gallery-image').removeData('elevateZoom');
    },
    createZoom: function(image){
      VINAGECKO.productMediaManager.destroyZoom();
      if(isMobileAlt){
        return;
      }
      if(image.length <= 0) { //no image found
        return;
      }
      if(image[0].naturalWidth && image[0].naturalHeight) {
        var widthDiff = image[0].naturalWidth - image.width() - imageZoomThreshold;
        var heightDiff = image[0].naturalHeight - image.height() - imageZoomThreshold;

        if(widthDiff < 0 && heightDiff < 0) {
          //image not big enough
          image.parents('.product-image').removeClass('zoom-available'); 
          return;
        } else {
          image.parents('.product-image').addClass('zoom-available');
        }
      }
      if(dataZoom.position == 'inside'){
        image.elevateZoom({
          //gallery:'more-slides',
          zoomType: "inner",
          easing : true,
          cursor: "crosshair"
        });
      }else {
        image.elevateZoom({
          //gallery:'more-slides',
          zoomWindowPosition: dataZoom.position,
          easing : true
        });
      }
      if(dataZoom.lightbox) {
        image.bind("click", function(e) {
          var ez =   image.data('elevateZoom');
          ez.closeAll();
          $.fancybox(ez.getGalleryList());
          return false;
        }); 
      }          	
    },
    swapImage: function(targetImage) {
      targetImage = $(targetImage);
      targetImage.addClass('gallery-image');

      VINAGECKO.productMediaManager.destroyZoom();

      var imageGallery = $('.product-image-gallery');

      if(targetImage[0].complete) { //image already loaded -- swap immediately

        imageGallery.find('.gallery-image').removeClass('visible');

        //move target image to correct place, in case it's necessary
        imageGallery.append(targetImage);

        //reveal new image
        targetImage.addClass('visible');

        //wire zoom on new image
        VINAGECKO.productMediaManager.createZoom(targetImage);

      } else { //need to wait for image to load

        //add spinner
        imageGallery.addClass('loading');

        //move target image to correct place, in case it's necessary
        imageGallery.append(targetImage);

        //wait until image is loaded
        imagesLoaded(targetImage, function() {
          //remove spinner
          imageGallery.removeClass('loading');

          //hide old image
          imageGallery.find('.gallery-image').removeClass('visible');

          //reveal new image
          targetImage.addClass('visible');

          //wire zoom on new image
          VINAGECKO.productMediaManager.createZoom(targetImage);
        });

      }
    },
    wireThumbnails: function() {
      //trigger image change event on thumbnail click
      $('.product-image-thumbs .thumb-link').click(function(e) {
        e.preventDefault();
        var jlink = $(this); 
        var target = $('#image-' + jlink.data('image-index')); 
        VINAGECKO.productMediaManager.swapImage(target);
      });
    },
    initZoom: function() {
      VINAGECKO.productMediaManager.createZoom($(".gallery-image.visible")); //set zoom on first image
    }, 
    init: function() {
      VINAGECKO.productMediaManager.imageWrapper = $('.product-img-box');

      // Re-initialize zoom on viewport size change since resizing causes problems with zoom and since smaller 
      $window.smartresize( function() {
        VINAGECKO.productMediaManager.initZoom();
      });

      VINAGECKO.productMediaManager.initZoom(); 
      VINAGECKO.productMediaManager.wireThumbnails();   
    }
  };
  VINAGECKO.boxScroll = {
    init: function(){
      if($('.scroll-div').length > 0){
        var scroll_div = $('.scroll-div');
        scroll_div.css("height",335);
        scroll_div.mCustomScrollbar({
          theme: "dark-2",
          scrollButtons: {
            enable: false
          }
        });
      }
    },
  };
  VINAGECKO.verticleScroll = {
    init: function(){
      if($('.product-img-box .verticl-carousel').length > 0){
        var carousel = $('.product-img-box .verticl-carousel'); 
        VINAGECKO.verticleScroll.carouselInit(carousel);
      }
    },
    carouselInit: function(carousel){
      var count = carousel.find('a').length;

      if (count <= 3) {
        carousel.parents('.more-views-verticle').find('.more-views-nav').hide();
      }

      $(".product-img-box #carousel-up").on("click", function () {
        if (!$(".product-img-box .verticl-carousel").is(':animated')) {
          var bottom = $(".product-img-box .verticl-carousel > a:last-child");
          var clone = $(".product-img-box .verticl-carousel > a:last-child").clone();
          clone.prependTo(".product-img-box .verticl-carousel");

          $(".product-img-box .verticl-carousel").animate({
            "top": "-=85"
          }, 0).stop().animate({
            "top": '+=85'
          }, 250, function () {
            bottom.remove();
          });

          VINAGECKO.productMediaManager.init();
        }
      });
      $(".product-img-box #carousel-down").on("click", function () {
        if (!$(".product-img-box .verticl-carousel").is(':animated')) {
          var top = $(".product-img-box .verticl-carousel > a:first-child");
          var clone = $(".product-img-box .verticl-carousel > a:first-child").clone();
          clone.appendTo(".product-img-box .verticl-carousel");

          $(".product-img-box .verticl-carousel").animate({
            "top": '-=85'
          }, 250, function () {
            top.remove();
            $(".product-img-box .verticl-carousel").animate({
              "top": "+=85"
            }, 0);
          });

          VINAGECKO.productMediaManager.init();
        }
      });
    }
  }

  var infowindow, bounds, directory_bounds, mapTypeIdentifier = "", mapType, mapColor, mapSaturation, mapCenterLat, mapCenterLng, companyPos = "", isDraggable = true, latitude, longitude, mapCoordinates, markersArray = [], pinTitle, pinContent, pinLink, address, pinButtonText, pinLogoURL = "";

  VINAGECKO.map = {
    init:function() {

      var maps = $('.map-canvas');
      var mapContainer;

      if (typeof google !== 'undefined') {
        bounds = new google.maps.LatLngBounds();
      }

      maps.each(function(i, element) {
        mapContainer = element;
        var mapZoom = mapContainer.getAttribute('data-zoom'),
            mapControls = mapContainer.getAttribute('data-controls') == "yes" ? '' : 'no';
        mapType = mapContainer.getAttribute('data-maptype');
        mapColor = mapContainer.getAttribute('data-mapcolor');
        mapCenterLat = mapContainer.getAttribute('data-center-lat');
        mapCenterLng = mapContainer.getAttribute('data-center-lng');
        mapSaturation = mapContainer.getAttribute('data-mapsaturation');

        VINAGECKO.map.createMap( mapContainer, mapZoom, mapControls, mapType, mapColor, mapSaturation, jQuery(this));
      });

    },
    getLatLong: function(address, pintit, pinimage, fn) {
      var geocoder;
      geocoder = new google.maps.Geocoder();
      geocoder.geocode( { 'address': address}, function(results, status) {
        fn(results[0].geometry.location, results[0].geometry.location.lat(), results[0].geometry.location.lng() , pintit, pinimage);
      });
    },
    addWinContent: function(marker, html, map) {
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.setContent(html);
        infowindow.open(map, marker);
      });
    },
    addMarker: function(mapInstance, pinLogoURL, pinTitle, pinContent, pinLink, address, pinButtonText) {
      var companyMarker;

      mapCoordinates = new google.maps.LatLng(latitude, longitude);

      if (pinLogoURL) {
        companyPos = new google.maps.LatLng(latitude, longitude);
        companyMarker = new google.maps.Marker({
          position: mapCoordinates,
          map: mapInstance,
          icon: pinLogoURL,
          animation: google.maps.Animation.DROP
        });
      } else {
        companyPos = new google.maps.LatLng(latitude, longitude);
        companyMarker = new google.maps.Marker({
          position: mapCoordinates,
          map: mapInstance,
          animation: google.maps.Animation.DROP
        });
      }

      var html = '<div class="pinmarker">';

      if (pinTitle !== "") {
        html += '<h3>'+pinTitle+'</h3>';
      }

      if (pinContent !== "") {
        html += '<p>'+pinContent+' </p>';
      }

      if (pinLink !== "" && pinButtonText !== "") {
        html += '<div><a href="' + pinLink + '" target="_blank">'+pinButtonText+'</a></div>';
      }

      html += '</div>';

      infowindow = new google.maps.InfoWindow();
      VINAGECKO.map.addWinContent(companyMarker, html, mapInstance);
      bounds.extend(mapCoordinates);
    },
    createMap: function(mapContainer, mapZoom, mapControls, mapType, mapColor, mapSaturation, targetMap) {

      if (google) {
        directory_bounds = new google.maps.LatLngBounds();
      }

      var pinLogoURL = "", mapLightness = false;

      // MAP STYLES
      var stylesArray = [],
          isStyled = false;

      if (jQuery(mapContainer).parent().find('.map-styles-array').length > 0) {
        isStyled = true;
        stylesArray = JSON.parse(jQuery(mapContainer).parent().find('.map-styles-array').text());
      } else {
        if (mapSaturation == "mono-light") {
          if (mapColor === "") {
            mapColor = "#ffffff";
          }
          mapSaturation = -100;
        } else if (mapSaturation == "mono-dark") {
          if (mapColor === "") {
            mapColor = "#222222";
          }
          mapSaturation = -100;
          mapLightness = true;
        } else {
          mapSaturation = -20;
        }
        stylesArray = [
          {
            stylers: [
              {hue: mapColor},
              {"invert_lightness": mapLightness},
              {saturation: mapSaturation}
            ]
          }
        ];
      }

      if (isMobileAlt) {
        isDraggable = false;
      }

      if (mapType === "satellite") {
        mapTypeIdentifier = google.maps.MapTypeId.SATELLITE;
      } else if (mapType === "terrain") {
        mapTypeIdentifier = google.maps.MapTypeId.TERRAIN;
      } else if (mapType === "hybrid") {
        mapTypeIdentifier = google.maps.MapTypeId.HYBRID;
      } else {
        mapTypeIdentifier = google.maps.MapTypeId.ROADMAP;
      }
      var options = {
        zoom: parseInt(mapZoom, 10),
        scrollwheel: false,
        draggable: isDraggable,
        mapTypeControl: true,
        disableDefaultUI: mapControls,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
        navigationControl: true,
        navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
        mapTypeId: mapTypeIdentifier,
        styles: stylesArray
      };

      var mapInstance = new google.maps.Map(mapContainer, options);
      var pincount = targetMap.parent().find('.pin_location').length;

      //Resize Window Responsiveness
      google.maps.event.addDomListener(window, 'resize', function() {
        mapInstance.fitBounds(bounds);
        mapInstance.setZoom(parseInt(mapZoom, 10));
      });

      bounds = new google.maps.LatLngBounds();

      targetMap.parent().find('.pin_location').each(function(i, element) {
        pinLogoURL = element.getAttribute('data-pinimage');
        pinTitle = element.getAttribute('data-title');
        pinContent = element.getAttribute('data-content');
        address = element.getAttribute('data-address');
        pinLink = element.getAttribute('data-pinlink');
        latitude = element.getAttribute('data-lat');
        longitude = element.getAttribute('data-lng');
        pinButtonText = element.getAttribute('data-button-text');

        if (latitude === '' && longitude === '') {
          VINAGECKO.map.getLatLong(address, pinTitle, pinLogoURL ,function(location, lati,longi, pintit, pinimage ){
            latitude = lati;
            longitude = longi;
            pinTitle = pintit;
            pinLogoURL = pinimage;

            VINAGECKO.map.addMarker(mapInstance, pinLogoURL, pinTitle, pinContent, pinLink, address, pinButtonText);

            if ( pincount > 1 ) {
              if(mapCenterLat !== '' && mapCenterLng !== ''){
                mapInstance.setZoom(parseInt(mapZoom, 10));
                mapInstance.setCenter(new google.maps.LatLng(mapCenterLat, mapCenterLng));
              }else{
                mapInstance.fitBounds(bounds);
              }
            } else {
              mapInstance.setZoom(parseInt(mapZoom, 10));
              mapInstance.setCenter(new google.maps.LatLng(latitude, longitude));
            }
          });
        } else {
          VINAGECKO.map.addMarker(mapInstance, pinLogoURL, pinTitle, pinContent, pinLink, address, pinButtonText);

          if ( pincount > 1 ) {
            if(mapCenterLat !== '' && mapCenterLng !== ''){
              mapInstance.setZoom(parseInt(mapZoom, 10));
              mapInstance.setCenter(new google.maps.LatLng(mapCenterLat, mapCenterLng));
            }else{
              mapInstance.fitBounds(bounds);
            }
          } else {
            mapInstance.setZoom(parseInt(mapZoom, 10));
            mapInstance.setCenter(new google.maps.LatLng(latitude, longitude));
          }
        }
      });
    }
  };

  VINAGECKO.blog = {
    init: function(){
      if($('.blog-article-wrap .owl-carousel').length > 0){
        var blogArticle = $('.owl-carousel');

        blogArticle.each(function(){
          VINAGECKO.blog.articleCarouselInit($(this));
        });
      }
    },
    articleCarouselInit: function(blogArticle){
      var carouselData = blogArticle.parent().find('data-carousel');

      if(carouselData.data('auto')) {
        var autoplay = carouselData.data('auto');
      }else{
        var autoplay = false;
      }
      blogArticle.owlCarousel({
        items: carouselData.data('items'), 
        slideSpeed: 500,
        autoPlay: autoplay,
        pagination: carouselData.data('paging'),
        addClassActive: true,
        navigation: carouselData.data('nav'),
        navigationText: [carouselData.data('prev'),carouselData.data('next')]
      }); 
    }
  };

  VINAGECKO.footer = {
    init: function() {
      VINAGECKO.footer.backToTopInit();
      VINAGECKO.footer.mobileAccordionInit();
    },
    backToTopInit: function() {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $('#back-top').fadeIn();
        } else {
          $('#back-top').fadeOut();
        }
      });

      $('#back-top a').click(function () {
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });
    },
    mobileAccordionInit: function() {
      /* $('.mobile-button').addClass("active"); */

      $('.mobile-button').click(function(){
        if($(this).parents('.footer-block-title, .block-title').next().is(":visible")){
          $(this).addClass("active");
        }else{
          $(this).removeClass("active");
        }
        $(this).parents('.footer-block-title, .block-title').next().toggle(400);
      });
    }
  };
  VINAGECKO.onReady = {
    init: function() {
      VINAGECKO.general.init();
      VINAGECKO.header.init();
      VINAGECKO.page.init();
      VINAGECKO.carouselSync.init();
      VINAGECKO.collection.init(); 
      VINAGECKO.blog.init();
      VINAGECKO.footer.init();
      VINAGECKO.boxScroll.init();
      VINAGECKO.verticleScroll.init();
      VINAGECKO.productMediaManager.init();
    }
  };
  VINAGECKO.onLoad = {
    init: function() { 
      VINAGECKO.map.init();
    }
  }; 
  $(document).ready(function(){
    VINAGECKO.onReady.init();
  });
  $(window).load(function(){
    VINAGECKO.onLoad.init();
  });
})(jQuery);

function mobileSkipLink(e){
  var skipContents = jQuery('.skip-content');
  var skipLinks = jQuery('.skip-link');
  var self = jQuery(e);
  var target = self.attr('data-target-element');
  // Get target element
  var elem = jQuery(target);
  // Check if stub is open
  var isSkipContentOpen = elem.hasClass('skip-active') ? 1 : 0;
  // Hide all stubs
  skipLinks.removeClass('skip-active');
  skipContents.removeClass('skip-active');
  self.removeClass('skip-active');
  // Toggle stubs
  if (isSkipContentOpen) {
    self.removeClass('skip-active');
  } else {
    self.addClass('skip-active');
    elem.addClass('skip-active');
  }
}